import styled from "styled-components";

export default styled.div`
  .active {
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.blue};
    gap: 0.4rem;
  }
`;
